import { render, staticRenderFns } from "./ContractorCollectionFiltersNew2.vue?vue&type=template&id=29ecd408"
import script from "./ContractorCollectionFiltersNew2.vue?vue&type=script&lang=ts"
export * from "./ContractorCollectionFiltersNew2.vue?vue&type=script&lang=ts"
import style0 from "./ContractorCollectionFiltersNew2.vue?vue&type=style&index=0&id=29ecd408&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ecd408')) {
      api.createRecord('29ecd408', component.options)
    } else {
      api.reload('29ecd408', component.options)
    }
    module.hot.accept("./ContractorCollectionFiltersNew2.vue?vue&type=template&id=29ecd408", function () {
      api.rerender('29ecd408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/ContractorCollectionFiltersNew2.vue"
export default component.exports